import { ReactComponent as QRCodeIcon } from '../../../../../../../assets/icons/invitationIcons/QRCodeIcon.svg';

export const QRCodeHeader = () => {
  return (
    <div className="flex text-primary-p3">
      <QRCodeIcon className="shrink-0" />
      <span className="font-semibold leading-6 pl-2">
        Have the patient scan the QR code with their phone's camera
      </span>
    </div>
  );
};
